import React from 'react';

import PropTypes from 'prop-types';

import styles from './StatisticsContainer.scss';

function StatisticsContainer(props) {
    const {
        children,
        className,
    } = props;

    return (
        <div className={`${styles.statisticsContainer} ${className}`}>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    ...child.props,
                    className: `${child.className} ${styles.statistic}`,
                });
            })}
        </div>
    );
}

StatisticsContainer.propTypes = {
    className: PropTypes.string,
};
StatisticsContainer.defaultProps = {
    className: '',
};

export default StatisticsContainer;
